import { ReactNode, useEffect, useState } from 'react';
import './FadeInWrapper.css';

interface FadeInWrapperProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}

const FadeInWrapper: React.FC<FadeInWrapperProps> = ({ 
  children, 
  delay = 0, 
  className = '' 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <div className={`fade-in-wrapper ${isVisible ? 'visible' : ''} ${className}`}>
      {children}
    </div>
  );
};

export default FadeInWrapper;